




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AuthRoot extends Vue {
  @Prop() private msg!: string;
}
